import React from "react";
import Button from "../../shared/Button";
import img from "../../../assets/img/Home/profile.png";
import { useUserInfo } from "../../../context/UserContext";
const EditResidenceHeader = () => {
  const {userinfo}=useUserInfo()

  return (
   <div className="">
        <div className="EditResidenceHeader">
      <Button varient="outline-gray">لغو عملیات و برگشت</Button>
      <div className="EditResidenceHeader-profile--box">
        <span>انتشار به عنوان</span>
        <img src={img} />
        <p>{userinfo.data.user.full_name}  </p>
      </div>
      <Button varient="primary">تغیر اطلاعات اقامتگاه</Button>
    </div>
   </div>
  );
};

export default EditResidenceHeader;
